import _o2sService from './_o2sServices';
import { IFilter } from '../models/filters/filter';
import { IProductionDilutorBathFilter } from '../models/filters/productionDilutorBathFilter';
import { IProductionDilutorBathForm } from '../models/forms/productionDilutorBathForm';
import { IProductionDilutorBathPDTO } from '../models/dtos/productionDilutorBathPDTO';
import { API_CENTRE } from './config';

export default class ProductionDilutorBathServices extends _o2sService {
   protected static override mainUrl:string = API_CENTRE + '/api/v1/ProductionDilutorBaths';
   protected static override getUrlFilter<F extends IProductionDilutorBathFilter>(filter?: F): string {;
       let url = super.getUrlFilter(filter as IFilter);
       if (filter != null) 
       {
           if (filter.productionId != null)
               url += '&ProductionId=' + filter.productionId;
           if (filter.dilutorBathId != null)
               url += '&DilutorBathId=' + filter.dilutorBathId;
       }
       return url;
   }

   public static override toDTO(dic: IProductionDilutorBathForm): IProductionDilutorBathPDTO {
       const dto = super.toDTO(dic) as IProductionDilutorBathPDTO;
       return dto;
   }

}
